import React from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { APITAGS } from "../../helpers/enums/apiTags";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock, faKey, faTag } from "@fortawesome/free-solid-svg-icons";
import { handleLogin } from "../../helpers/authUtil";
import "../APILibrary/LibraryCard.css"

const LibraryCard = ({ api, searchVal }) => {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const trimmedSearch = searchVal?.trim().toLowerCase();
  const highlightMatch = (text, trimmedSearch) => {
    if (!trimmedSearch) return text;
  
    const regex = new RegExp(`(${trimmedSearch})`, "gi");
    const parts = text.split(regex);
  
    return parts.map((part, i) =>
      regex.test(part) ? <mark key={i}>{part}</mark> : part
    );
  };

  const handleOnClick = (apiInfo) => {
    let redirectPath = window.location.origin + apiInfo.link
    if (apiInfo.tags.includes(APITAGS.INTERNAL)) {
      if (isAuthenticated) {
        window.location.href = redirectPath
      } else {
        sessionStorage.setItem('postLoginUrl', apiInfo.link)
        handleLogin(instance);
      }
    } else {
      window.location.href = redirectPath
    }
  }

  const handleOnKeyDown = (event, apiInfo) => {
    if (event.key === 'Enter') {
      let redirectPath = window.location.origin + apiInfo.link
      if (apiInfo.tags.includes(APITAGS.INTERNAL)) {
        if (isAuthenticated) {
          window.location.href = redirectPath
        } else {
          sessionStorage.setItem('postLoginUrl', apiInfo.link)
          handleLogin(instance);
        }
      } else {
        window.location.href = redirectPath
      }
    }
  }

  const authTypesList = (api) => {
    return (
      <div className="tag-list">
        {api.authTypes.map((type, index) => (
          <div key={index}>{parseAuthType(type)}</div>
        ))}
      </div>
    );
  }

  const topicsList = (api) => {
    return (
      <div className="tag-list">
        {api.topics.map((topic, index) => (
          <div key={index}>{parseTopics(topic)}</div>
        ))}
      </div>
    );
  }

  const parseAuthType = (authType) => {
    if (!authType) return '';
    const result = authType
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (char) => char.toUpperCase());

    if (result === 'Sams Credentials') {
      return <div aria-label="sams-creds" className="auth-container"><FontAwesomeIcon className="cg" icon={faKey} /><div className="cal-sans-regular">SAMS Credentials</div></div>
    } else {
      return <div aria-label="key" className="auth-container"><FontAwesomeIcon className="cg" icon={faKey} /><div className="cal-sans-regular">{result}</div></div>
    }
  }

  const parseTopics = (topic) => {
    if (topic === "cdcOnly") {
      return <div aria-label="cdc-only" className="auth-container"><FontAwesomeIcon className="cg" icon={faLock} /><div className="cal-sans-regular">CDC Only</div></div>
    } else {
      return <div aria-label="lock" className="auth-container"><FontAwesomeIcon className="cg" icon={faTag} /><div className="cal-sans-regular">{topic.toUpperCase()}</div></div>
    } 
  }

  return (
    <div onClick={() => handleOnClick(api)} className="library-card-box">
      <div className="library-card bg-white phone-card">
        <p className="title flex-md-gap">
          <div role="button" tabIndex={0} onKeyDown={(event => { handleOnKeyDown(event, api)})}>
            {highlightMatch(api.name, trimmedSearch)}
          </div>
          <div>
            {topicsList(api)}
          </div>
        </p>
        <p>{highlightMatch(api.description, trimmedSearch)}</p>
        {authTypesList(api)}
      </div>
    </div>
  );
};

// used for dynamic API lists
// const LibraryCard = ({ api, description }) => {
//   const cardContent = (
//     <div className="tablet:padding-x-2 padding-y-1 margin-y-5 library-card bg-white">
//       <p className={api.link ? "title" : "title-nolink"}>
//         {api.apiName || "No API Name"}
//       </p>
//       <p>{description || "No Description Available"}</p>
//     </div>
//   );

//   return api.link ? (
//     <a href={api.link} className="library-card-box">
//       {cardContent}
//     </a>
//   ) : (
//     <div className="library-card-box">{cardContent}</div>
//   );
// };

export default LibraryCard;
